import React from "react";
import Navigation from "./Web_Application/Navigation";
// import Nav_header from "./Web_Application/Nav_header";
import Carousel from "./Web_Application/Carousel";
import About from "./Web_Application/About";
import Download from "./Web_Application/Download";
import Programming from "./Web_Application/Programming";
import Reviews from "./Web_Application/Reviews";
import Service from "./Web_Application/Service";
import Team from "./Web_Application/Team";
import OurWorks from "./Web_Application/OurWorks";
import Join from "./Web_Application/Joinus";
import Contact from "./Web_Application/Contacts";
import Footer from "./Web_Application/footer";
function Home() {
  return (
    <div className="About">
        {/* <h1>this is in come to my our success</h1> */}
            {/* <Nav_header/> */}
            <Navigation/>
            <Carousel />
            <About />
            <Download />
            <Programming />
            <Reviews/>
            <Service/>
            <Team/>
            <OurWorks/>
            <Join/>
            <Contact/>
            <Footer/>
            
    
    </div>
  );
};

export default Home;
